export default __webpack_public_path__ + "static/media/drag.8f065dfc.svg";